import React from "react";
import me from "../assets/Gautam.png";
import {
  AiFillGithub,
  AiFillInstagram,
  AiFillFacebook,
  AiOutlineArrowUp,
} from "react-icons/ai";

const Footer = () => {
  return (
    <footer>
      <div>
        <img
          src={me}
          alt="Founder"
        />

        <h2>Gautam Kumar</h2>
        <p>Motivation is temporary, but discipline last forever.</p>
      </div>

      <aside>
        <h2>Social Media</h2>

        <article>
          <a href="https://www.facebook.com/GAUTAMKUMAR731960/" target={"blank"}>
            <AiFillFacebook />
          </a>
          <a href="https://www.instagram.com/gautamcodes24/" target={"blank"}>
            <AiFillInstagram />
          </a>
          <a href="https://github.com/Gautamcodes24" target={"blank"}>
            <AiFillGithub />
          </a>
        </article>
      </aside>
      <a href="#home">
        <AiOutlineArrowUp />
      </a>
    </footer>
  );
};

export default Footer;
